import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import VehicleCollectionForm from "@/components/application/VehicleCollectionForm";
import ApplicationStepper from "@/components/application/ApplicationStepper";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useActiveJob } from "@/contexts/ActiveJobContext";

// Initialize Stripe with your publishable key and disable Link
const stripePromise = loadStripe(
  import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ||
    "pk_test_51SD35zJurFX4ulkDTvGnag5Ljjj1uvkwSGgDmyix7C0N99jo0wXBSkfm3KrxfEcqbDMQLewy0BNQRkdeyKgwtPZI00kzfWpkVv",
  {
    betas: [],
  }
);

const VehicleCollectionPage = () => {
  const { job } = useActiveJob();

  // Check if payment-info segment exists in vehicle-collection stage
  const vehicleCollectionStage = job?.stages?.find(
    (s) => s.id === "vehicle-collection"
  );
  const hasPaymentSegment = vehicleCollectionStage?.segments?.some(
    (seg) => seg.id === "payment-info"
  );

  // Build description based on segments
  const description = hasPaymentSegment
    ? "Complete payment information and schedule your vehicle collection"
    : "Schedule your vehicle collection appointment";

  return (
    <AppLayout>
      <div className="container mx-auto px-4 md:px-8 pb-8">
        <ApplicationStepper />

        <h1 className="text-2xl font-bold mb-2 text-jungle text-center md:text-2xl">
          Vehicle Collection
        </h1>
        <p className="text-gray-600 mb-8 text-center">{description}</p>

        <div className="max-w-2xl mx-auto">
          <Elements
            stripe={stripePromise}
            options={{
              loader: "auto",
              // Disable Link
              appearance: {
                disableAnimations: false,
              },
            }}
          >
            <VehicleCollectionForm />
          </Elements>
        </div>
      </div>
    </AppLayout>
  );
};

export default VehicleCollectionPage;
